export default __webpack_public_path__ + "static/media/point-drag-handle.d37789ba.svg";